export default "__VITE_ASSET__6694eb05__"